import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const $ = jQuery.noConflict();

const HeroKibarro = {
	$section: $('.js-hero-kibarro'),
	$image: $('.js-hero-kibarro-image'),
	$logoInitial: $('.js-hero-kibarro-logo-initial'),
	$content: $('.js-hero-kibarro-content'),

	init: function() {
		if (!this.$section.length) return;
		this.animate();
	},

	animate: function() {
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: this.$section[0],
				start: 'top top',
				end: 'bottom bottom',
				scrub: 1.2,
			}
		});

		// Phase 1 (0 → 0.40): initial logo fades out + image pans up to reveal people
		// yPercent: -16.67 = moves image up exactly 20vh (16.67% of 120vh height)
		tl.to(this.$logoInitial[0], {
			opacity: 0,
			ease: 'power1.inOut',
			duration: 0.4,
		}, 0);

		const yPercentEnd = window.innerWidth < 576 ? -3.33 : -13.33;

		tl.fromTo(this.$image[0], {
			yPercent: 0,
		}, {
			yPercent: yPercentEnd,
			ease: 'none',
			duration: 0.45,
		}, 0);

		// Phase 2 (0.42 → 0.57): content container fades in
		tl.fromTo(this.$content[0], {
			opacity: 0,
			y: 20,
		}, {
			opacity: 1,
			y: 0,
			ease: 'power2.out',
			duration: 0.15,
			onComplete: () => {
				this.$content.css('pointer-events', 'auto');
			},
		}, 0.42);
	}
};

export default HeroKibarro;
